<template>
    <modal width="500" height="auto" name="pc-ideabook-recommendation-modal" data-html2canvas-ignore="true"
        :adaptive="true" class="pc-ideabook-recommendation-modal" :scrollable="false">
        <div class="pc-ideabook-recommendation-modal-container">
            <button class="ideabook-recommendation-modal-button-close btn button-full" type="button" @click="closeModal">
                <span class="png-icon png-icon-icons-symbols--k-txtclose" aria-label="Close modal"></span>
            </button>
            <div class="pc-ideabook-recommendation-modal-wrapper">
                <div class="ideabook-recommendations-heading">
                    <h5 class="primary-heading">{{ $resourceString['myBasket.IdeaBook.Recommendations.Title'] }}:</h5>
                    <p class="primary-description">{{ $resourceString['myBasket.IdeaBook.Label.IdeaBook'] }} {{
                        basketItems.LatestIdeaBook.IdeabookPublicationYear }}</p>
                    <p class="primary-description">{{ basketItems.LatestIdeaBook.IdeabookName }}</p>
                </div>
                <div class="ideabook-recommendations-details">
                    <div class="ideabook-recommendations-coverimage">
                        <img :src="basketItems.LatestIdeaBook.IdeabookCoverImage.replace('~', '')" alt="" />
                    </div>
                </div>
                <div class="ideabook-recommendations-buttons">
                    <button type="button"  class="btn btn-primary next-btn" @click="continueToCheckOut(true, false)">
                        {{ $resourceString["checkout.Ideabook.Modal.AddToCart"] }}
                    </button>
                    <button class="btn btn-white border border-dark next-btn" type="button" @click="continueToCheckOut(false, true)">
                        {{ $resourceString["checkout.Ideabook.Modal.Proceed"] }}
                    </button>
                </div>
            </div>
        </div>
    </modal>
</template>

<script>
import { mapGetters } from 'vuex';
export default {
    props: ["continueToCheckOut"],
    computed: {
        ...mapGetters({
            basketItems: "newBasketPage/getBasketItems",
        })
    },
    methods: {       
        closeModal() {
            this.$modal.hide("pc-ideabook-recommendation-modal");
        },
    },
}
</script>
